import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Box } from '../box';
import { Tooltip } from '../tooltip';
import { Popover } from '.';
export const PopoverWithTooltip = (props) => {
    const { tooltip, ...popoverProps } = props;
    const [popoverOpen, setPopoverOpen] = React.useState(false);
    const [tooltipOpen, setTooltipOpen] = React.useState(false);
    const [tooltipBlocked, setTooltipBlocked] = React.useState(false);
    return props.children ? (_jsx(Tooltip, { open: tooltipBlocked ? false : tooltipOpen, title: tooltip, onVisibilityChange: (state) => {
            if (!tooltipBlocked) {
                setTooltipOpen(state);
            }
        }, children: _jsx(Box, { width: "max-content", children: _jsx(Popover, { ...popoverProps, open: popoverOpen, onOpen: () => {
                    setPopoverOpen(true);
                    setTooltipBlocked(true);
                    popoverProps.onOpen?.();
                }, onClose: () => {
                    setPopoverOpen(false);
                    setTimeout(() => setTooltipBlocked(false), 500);
                    popoverProps.onClose?.();
                }, children: props.children }) }) })) : null;
};
